'use client';

import { Check } from 'lucide-react';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getDeliveryDays } from '../../utils/fervi-availability';

type FerviAvailabilityProps = {
  availability?: {
    name?: string;
    color?: string | null;
    color_text?: string | null;
    sellable?: boolean;
    availability_in_days?: number | string | null;
  } | null;
  showDeliveryDays?: boolean;
  compact?: boolean;
};

export function FerviAvailability({
  availability,
  showDeliveryDays = false,
  compact = false,
}: FerviAvailabilityProps) {
  const { t } = useTranslations();
  if (!availability?.name) return null;

  const days = getDeliveryDays(availability.availability_in_days);
  const color =
    availability.color_text || (availability.sellable === false ? '#B80900' : '#009821');

  return (
    <div className="ea-fervi-availability flex max-w-full flex-col items-start gap-1">
      <span
        className={cn(
          'inline-flex max-w-full items-center gap-2 rounded-full px-3 py-1.5',
          compact ? 'text-xs' : 'min-h-[36px] text-sm',
        )}
        style={{
          color,
          backgroundColor:
            availability.color || (availability.sellable === false ? '#FFD3D1' : '#C2FFBD'),
        }}
      >
        <Check aria-hidden="true" className="h-4 w-4 shrink-0" />
        <span className="break-words">{availability.name}</span>
      </span>
      {showDeliveryDays && days !== null && (
        <span className="ea-fervi-availability__delivery-days text-xs" style={{ color }}>
          {t('text3497')}: {days} {t(days === 1 ? 'text1976' : days <= 4 ? 'text1977' : 'text1978')}
        </span>
      )}
    </div>
  );
}
